import { useEffect } from 'react';
import PropTypes from 'prop-types';

import Box from '@mui/material/Box';

import { useBoolean } from 'src/hooks/use-boolean';
import { useResponsive } from 'src/hooks/use-responsive';

import { startExtensionQueueOnOpen } from 'src/utils/extension-queue';

import { useSettingsContext } from 'src/components/settings';

import { WhatsNewProvider } from 'src/sections/changelog/whats-new-context';

import Main from './main';
import Header from './header';
import NavMini from './nav-mini';
import NavVertical from './nav-vertical';
import NavHorizontal from './nav-horizontal';

// ----------------------------------------------------------------------

export default function DashboardLayout({ children }) {
  const settings = useSettingsContext();

  // The work the seller's browser owes their marketplaces runs now that they are here.
  useEffect(() => {
    startExtensionQueueOnOpen().catch(() => {});
  }, []);

  const lgUp = useResponsive('up', 'lg');

  const nav = useBoolean();

  const isHorizontal = settings.themeLayout === 'horizontal';

  const isMini = settings.themeLayout === 'mini';

  const renderNavMini = <NavMini />;

  const renderHorizontal = <NavHorizontal />;

  const renderNavVertical = <NavVertical openNav={nav.value} onCloseNav={nav.onFalse} />;

  const renderNav = () => {
    if (isHorizontal) return lgUp ? renderHorizontal : renderNavVertical;
    if (isMini) return lgUp ? renderNavMini : renderNavVertical;
    return renderNavVertical;
  };

  // The header's "What's new" button and the dashboard's "New in Voolist" window share what the seller has
  // already seen.
  return (
    <WhatsNewProvider>
      <Header onOpenNav={nav.onTrue} />

      {isHorizontal ? (
        <>
          {renderNav()}

          <Main>{children}</Main>
        </>
      ) : (
        <Box
          sx={{
            minHeight: 1,
            display: 'flex',
            flexDirection: { xs: 'column', lg: 'row' },
          }}
        >
          {renderNav()}

          <Main>{children}</Main>
        </Box>
      )}
    </WhatsNewProvider>
  );
}

DashboardLayout.propTypes = {
  children: PropTypes.node,
};
